import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LmrComponent } from './lmr.component';
import { DealersComponent } from './pages/dealers/dealers.component';
import { BidComponent } from '../lmr/pages/bid/bid.component';
import { DefectSolutionComponent } from './pages/defect-solution/defect-solution.component';
import { HeadOfficeComponent } from './pages/head-office/head-office.component';
import { RepairTrackingComponent } from './pages/repair-tracking/repair-tracking.component';
import { RepairTrackingDetailsComponent } from './pages/repair-tracking-details/repair-tracking-details.component';

const routes: Routes = [
  {
    path: '',
    component: LmrComponent,
  },
  {
    path: 'dealers',
    component: DealersComponent,
  },
  {
    path: 'bid',
    component: BidComponent,
  },
  {
    path: 'defect-solution',
    component: DefectSolutionComponent,
  },
  {
    path: 'matriz',
    component: HeadOfficeComponent,
  },
  {
    path: 'acompanhamento-reparo',
    component: RepairTrackingComponent,
  },
  {
    path: 'acompanhamento-reparo/:tradeId',
    component: RepairTrackingDetailsComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LmrRoutingModule {}
